// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2024-01-26
// Modified By: Zachary Thomas
//
// Copyright 2022 - 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { PRIVACY_POLICY, EULA } from "../../constants/miscellaneous";
import styles from "./Footer.module.scss";

// General footer.
export default function Footer(): Component {
  const date = new Date();

  return (
    <footer className={`${styles.body} py-1 px-3`}>
      <div className="row">
        <div className="col-auto me-3">
          <a className={styles.link} href={EULA} target="_blank" rel="noopener noreferrer">
            EULA
          </a>
        </div>
        <div className="col-auto me-3">
          <a className={styles.link} href={PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </div>

        <div className="col-auto col-xs ms-auto">
          <span className={styles.copyright}>
            &#xA9; {date.getFullYear()}, Cornell Pump Company. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
